(() => {
  'use strict';
  const cfg = window.O26 || {};
  const root = cfg.root || '/';
  const currency = cfg.currency || 'CAD';
  const qs = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => [...c.querySelectorAll(s)];
  const wait = ms => new Promise(r => setTimeout(r, ms));
  const debounce = (fn, delay = 220) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), delay); }; };
  const money = cents => { try { return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(cents || 0) / 100); } catch { return (Number(cents || 0) / 100).toFixed(2); } };
  const escapeHtml = (s = '') => String(s).replace(/[&<>'"]/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;' }[c]));
  const lock = on => document.body.classList.toggle('o26-lock', !!on);
  const toast = msg => { const el = qs('[data-toast]'); if (!el) return; el.textContent = msg; el.classList.add('is-visible'); clearTimeout(el._t); el._t = setTimeout(() => el.classList.remove('is-visible'), 2200); };

  // reveal motion
  const reveals = qsa('[data-reveal]');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } }), { threshold: .08, rootMargin: '0px 0px -30px' });
    reveals.forEach(el => io.observe(el));
  } else reveals.forEach(el => el.classList.add('is-visible'));

  // header
  const header = qs('[data-site-header]');
  const setHeader = () => header && header.classList.toggle('is-scrolled', scrollY > 12);
  setHeader(); addEventListener('scroll', setHeader, { passive: true });

  // mobile menu
  const menuBtn = qs('[data-menu-toggle]');
  const mobileNav = qs('[data-mobile-nav]');
  const closeMenu = () => { if (!menuBtn || !mobileNav) return; menuBtn.setAttribute('aria-expanded', 'false'); menuBtn.classList.remove('is-open'); mobileNav.hidden = true; };
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => { const open = menuBtn.getAttribute('aria-expanded') === 'true'; menuBtn.setAttribute('aria-expanded', String(!open)); menuBtn.classList.toggle('is-open', !open); mobileNav.hidden = open; });
    qsa('a', mobileNav).forEach(a => a.addEventListener('click', closeMenu));
  }

  // search + predictive search
  const search = qs('[data-search-overlay]');
  const searchShade = qs('[data-search-shade]');
  const searchInput = qs('[data-search-input]');
  const pred = qs('[data-predictive-results]');
  const openSearch = () => { if (!search) return; closeMenu(); search.setAttribute('aria-hidden','false'); search.classList.add('is-open'); if (searchShade) { searchShade.hidden = false; requestAnimationFrame(() => searchShade.classList.add('is-open')); } lock(true); setTimeout(() => searchInput && searchInput.focus(), 150); };
  const closeSearch = () => { if (!search) return; search.setAttribute('aria-hidden','true'); search.classList.remove('is-open'); if (searchShade) { searchShade.classList.remove('is-open'); setTimeout(() => searchShade.hidden = true, 230); } lock(false); };
  qsa('[data-search-open]').forEach(b => b.addEventListener('click', openSearch));
  qsa('[data-search-close]').forEach(b => b.addEventListener('click', closeSearch));
  searchShade?.addEventListener('click', closeSearch);
  const predictive = debounce(async term => {
    if (!pred) return;
    if (!term || term.trim().length < 2) { pred.innerHTML = ''; return; }
    try {
      pred.innerHTML = '<p class="o26-muted">Searching…</p>';
      const base = cfg.predictiveSearchUrl || root + 'search/suggest';
      const url = `${base}?q=${encodeURIComponent(term.trim())}&resources[type]=product&resources[limit]=4&section_id=predictive-search`;
      const r = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!r.ok) throw new Error('Search unavailable');
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector('#shopify-section-predictive-search');
      pred.innerHTML = section ? section.innerHTML : html;
    } catch { pred.innerHTML = ''; }
  }, 180);
  searchInput?.addEventListener('input', e => predictive(e.target.value));

  // cart drawer
  const drawer = qs('[data-cart-drawer]');
  const shade = qs('[data-cart-shade]');
  const drawerItems = qs('[data-cart-drawer-items]');
  const drawerTotal = qs('[data-cart-drawer-total]');
  const openDrawer = () => { if (!drawer) return; drawer.setAttribute('aria-hidden','false'); drawer.classList.add('is-open'); if (shade) { shade.hidden = false; requestAnimationFrame(() => shade.classList.add('is-open')); } lock(true); };
  const closeDrawer = () => { if (!drawer) return; drawer.setAttribute('aria-hidden','true'); drawer.classList.remove('is-open'); if (shade) { shade.classList.remove('is-open'); setTimeout(() => shade.hidden = true, 230); } lock(false); };
  const getCart = async () => { const r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); if (!r.ok) throw new Error('Cart unavailable'); return r.json(); };
  const updateCount = n => qsa('[data-cart-count]').forEach(el => el.textContent = n);
  const renderCart = cart => {
    updateCount(cart.item_count);
    if (drawerTotal) drawerTotal.textContent = money(cart.total_price);
    if (!drawerItems) return;
    if (!cart.items.length) {
      drawerItems.innerHTML = `<div class="o26-empty-state"><img src="${escapeHtml(qs('.o26-footer__bottom img')?.src || '')}" alt=""><h2>Your bag is empty.</h2><a class="o26-btn" href="${root}collections/all">Shop the drop</a></div>`;
      return;
    }
    drawerItems.innerHTML = cart.items.map((item, i) => `
      <div class="o26-drawer-line">
        <a href="${escapeHtml(item.url)}" class="o26-drawer-line__image">${item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : ''}</a>
        <div><a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.product_title)}</strong></a><span>${item.variant_title && item.variant_title !== 'Default Title' ? escapeHtml(item.variant_title) : ''}</span><div class="o26-drawer-qty"><button type="button" data-drawer-change="${i+1}" data-qty="${Math.max(0,item.quantity-1)}">−</button><span>${item.quantity}</span><button type="button" data-drawer-change="${i+1}" data-qty="${item.quantity+1}">+</button></div></div>
        <div class="o26-drawer-price">${money(item.final_line_price)}<button type="button" class="o26-remove" data-drawer-change="${i+1}" data-qty="0">Remove</button></div>
      </div>`).join('');
    qsa('[data-drawer-change]', drawerItems).forEach(btn => btn.addEventListener('click', () => changeLine(btn.dataset.drawerChange, btn.dataset.qty)));
  };
  const refreshCart = async (open = false) => { try { const cart = await getCart(); renderCart(cart); if (open) openDrawer(); } catch (e) { console.error(e); } };
  const changeLine = async (line, quantity) => { try { const r = await fetch(root + 'cart/change.js', { method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({line:Number(line), quantity:Number(quantity)}) }); if (!r.ok) throw new Error(); renderCart(await r.json()); } catch { toast('Could not update bag'); } };
  qsa('[data-cart-open]').forEach(b => b.addEventListener('click', () => refreshCart(true)));
  qsa('[data-cart-close]').forEach(b => b.addEventListener('click', closeDrawer));
  shade?.addEventListener('click', closeDrawer);

  // product gallery
  qsa('[data-product-root]').forEach(productRoot => {
    const gallery = qs('[data-gallery]', productRoot);
    const items = qsa('[data-gallery-image]', productRoot);
    const thumbs = qsa('[data-thumb]', productRoot);
    const counter = qs('[data-gallery-current]', productRoot);
    if (!gallery || !items.length) return;
    let activeIndex = 0, scrollFrame;

    const setState = index => {
      activeIndex = (index + items.length) % items.length;
      const mobile = matchMedia('(max-width: 780px)').matches;
      items.forEach((item, i) => {
        const active = i === activeIndex;
        item.hidden = mobile ? false : !active;
        item.classList.toggle('is-active', active);
      });
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === activeIndex));
      if (counter) counter.textContent = String(activeIndex + 1);
    };

    const go = (index, smooth = true) => {
      const next = (index + items.length) % items.length;
      setState(next);
      if (matchMedia('(max-width: 780px)').matches) gallery.scrollTo({ left: items[next].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    };
    productRoot._o26GalleryGo = go;
    productRoot._o26GalleryItems = items;

    thumbs.forEach((btn, i) => btn.addEventListener('click', () => go(i)));
    qs('[data-gallery-prev]', productRoot)?.addEventListener('click', () => go(activeIndex - 1));
    qs('[data-gallery-next]', productRoot)?.addEventListener('click', () => go(activeIndex + 1));
    gallery.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(activeIndex - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(activeIndex + 1); }
    });
    gallery.addEventListener('scroll', () => {
      if (!matchMedia('(max-width: 780px)').matches) return;
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        let nearest = 0, distance = Infinity;
        items.forEach((item, i) => { const d = Math.abs(item.offsetLeft - gallery.scrollLeft); if (d < distance) { distance = d; nearest = i; } });
        setState(nearest);
      });
    }, { passive:true });
    setState(0);
  });

  // main product variants
  qsa('[data-product-root]').forEach(productRoot => {
    const form = qs('[data-o26-product-form]', productRoot);
    if (!form) return;
    const variantsEl = qs('[data-product-variants]', form);
    if (!variantsEl) return; // quick-add forms are handled separately below
    let variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch {}
    const variantId = qs('[data-variant-id]', form);
    const priceEl = qs('[data-product-price]', productRoot);
    const compareEl = qs('[data-compare-price]', productRoot);
    const addBtn = qs('.o26-add-btn', form);
    const addText = qs('[data-add-text]', addBtn || form);
    const stock = qs('[data-stock-message]', productRoot);
    const mobileAtc = qs('[data-mobile-atc]', productRoot);
    const mobilePrice = qs('[data-mobile-price]', productRoot);
    const mobileBtn = qs('[data-mobile-atc-button]', productRoot);
    const optionGroups = qsa('.o26-option', form);

    const isColorGroup = fs => /colou?r/i.test(fs?.dataset.optionName || '');
    const currentOptions = () => optionGroups.map(fs => qs('input:checked', fs)?.value || null);
    const findVariant = opts => variants.find(v => v.options.every((o, i) => o === opts[i]));
    const firstAvailableFor = (index, value) => variants.find(v => v.available && v.options[index] === value);

    const selectMedia = v => {
      if (!v) return;
      let mediaId = v.featured_media_id;
      // If this exact variant has no media, fall back to another variant with the same selected color.
      if (!mediaId) {
        const opts = currentOptions();
        const colorIndex = optionGroups.findIndex(isColorGroup);
        if (colorIndex >= 0 && opts[colorIndex]) {
          const sameColor = variants.find(x => x.options[colorIndex] === opts[colorIndex] && x.featured_media_id);
          mediaId = sameColor?.featured_media_id || null;
        }
      }
      if (!mediaId) return;
      const id = String(mediaId);
      const target = qsa('[data-gallery-image]', productRoot).find(x => x.dataset.mediaId === id);
      if (!target) return;
      const galleryItems = productRoot._o26GalleryItems || qsa('[data-gallery-image]', productRoot);
      const mediaIndex = galleryItems.indexOf(target);
      if (productRoot._o26GalleryGo && mediaIndex >= 0) productRoot._o26GalleryGo(mediaIndex);
      else {
        galleryItems.forEach(x => { const active = x === target; x.hidden = !active; x.classList.toggle('is-active', active); });
        qsa('[data-thumb]', productRoot).forEach(x => x.classList.toggle('is-active', x.dataset.mediaId === id));
      }
    };

    const updateOptionAvailability = () => {
      const selected = currentOptions();
      optionGroups.forEach((fs, index) => {
        const colorGroup = isColorGroup(fs);
        qsa('label', fs).forEach(label => {
          const input = qs('input', label);
          if (!input) return;
          const value = input.value;
          let available;
          if (colorGroup) {
            // Colors stay selectable if that color exists in any in-stock variant.
            available = variants.some(v => v.available && v.options[index] === value);
          } else {
            // Sizes/options reflect the currently selected color and other choices.
            const candidate = [...selected];
            candidate[index] = value;
            available = variants.some(v => v.available && v.options.every((o, i) => {
              if (i === index) return o === value;
              if (selected[i] == null) return true;
              return o === candidate[i];
            }));
          }
          input.disabled = !available;
          label.classList.toggle('is-sold-out', !available);
          label.setAttribute('aria-disabled', String(!available));
        });
      });
    };

    const ensureAvailableSelection = changedIndex => {
      let opts = currentOptions();
      let exact = findVariant(opts);
      if (exact?.available) return exact;

      // If a color was changed and the selected size is sold out, automatically choose
      // the first available size in that color while keeping the color selection.
      const changedValue = opts[changedIndex];
      let fallback = firstAvailableFor(changedIndex, changedValue);
      if (!fallback) fallback = variants.find(v => v.available);
      if (!fallback) return exact || null;

      optionGroups.forEach((fs, i) => {
        const input = qsa('input', fs).find(r => r.value === fallback.options[i]);
        if (input) input.checked = true;
      });
      return fallback;
    };

    const sync = (changedIndex = -1) => {
      let v = changedIndex >= 0 ? ensureAvailableSelection(changedIndex) : findVariant(currentOptions());
      if (!v && variants.length) v = variants.find(x => x.available) || variants[0];

      qsa('.o26-option', form).forEach(fs => {
        const text = qs('[data-selected-option]', fs), checked = qs('input:checked', fs);
        if (text && checked) text.textContent = checked.value;
      });
      updateOptionAvailability();

      if (!v) { if (addBtn) addBtn.disabled = true; return; }
      if (variantId) variantId.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (mobilePrice) mobilePrice.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.hidden = false; compareEl.textContent = money(v.compare_at_price); }
        else compareEl.hidden = true;
      }
      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (mobileBtn) { mobileBtn.disabled = !v.available; mobileBtn.textContent = v.available ? 'Add to bag' : 'Sold out'; }
      if (stock) stock.innerHTML = v.available ? '<span class="is-in"></span> In stock' : '<span></span> Sold out';
      selectMedia(v);
      try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch {}
    };

    optionGroups.forEach((fs, index) => qsa('input', fs).forEach(r => r.addEventListener('change', () => sync(index))));
    sync();

    const qty = qs('[data-qty-input]', form);
    qs('[data-qty-minus]', form)?.addEventListener('click', () => qty.value = Math.max(1, Number(qty.value || 1) - 1));
    qs('[data-qty-plus]', form)?.addEventListener('click', () => qty.value = Number(qty.value || 1) + 1);
    mobileBtn?.addEventListener('click', () => form.requestSubmit(addBtn));
    if (mobileAtc && addBtn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => mobileAtc.classList.toggle('is-visible', !e.isIntersecting), { threshold: .1 }); io.observe(addBtn);
    }
  });

  // AJAX add to bag for every product form
  qsa('[data-o26-product-form]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = e.submitter || qs('button[type="submit"]', form);
      const msg = qs('[data-product-message]', form);
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      try {
        const r = await fetch(root + 'cart/add.js', { method:'POST', headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}, body:new FormData(form) });
        const data = await r.json();
        if (!r.ok) throw new Error(data.description || 'Could not add item');
        if (msg) msg.textContent = 'Added to bag.';
        toast('Added to bag');
        await refreshCart(true);
      } catch (err) { if (msg) msg.textContent = err.message; toast(err.message); }
      finally {
        if (btn) { btn.classList.remove('is-loading'); const vId = qs('[data-variant-id]', form)?.value; const variantsEl = qs('[data-product-variants]', form); let can = true; if (variantsEl && vId) { try { const vs = JSON.parse(variantsEl.textContent); can = vs.find(v => String(v.id) === String(vId))?.available !== false; } catch {} } btn.disabled = !can; }
      }
    });
  });

  // sort
  qsa('[data-sort-select]').forEach(s => s.addEventListener('change', () => s.form?.submit()));

  // product recommendations
  qsa('[data-product-recommendations]').forEach(async el => {
    if (!el.dataset.url) return;
    try {
      const r = await fetch(el.dataset.url, { headers: { Accept: 'text/html' } });
      if (!r.ok) throw new Error('Recommendations unavailable');
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-product-recommendations]');
      if (fresh?.innerHTML.trim()) {
        el.innerHTML = fresh.innerHTML;
        // Recommendation cards are injected after the initial reveal observer runs.
        // Force any injected reveal elements visible so images/text never remain hidden.
        qsa('[data-reveal]', el).forEach(card => card.classList.add('is-visible'));
        // Encourage lazy-loaded images inserted after page load to resolve immediately.
        qsa('img[loading=\"lazy\"]', el).forEach(img => {
          if (img.dataset.src && !img.src) img.src = img.dataset.src;
        });
      }
    } catch (err) { console.warn('ORDER 26 recommendations:', err); }
  });

  // Homepage campaign slideshow. Supports image and Shopify-hosted video slides.
  qsa('[data-o26-media-hero]').forEach(hero => {
    const slides = qsa('[data-o26-hero-slide]', hero);
    const dots = qsa('[data-o26-hero-dot]', hero);
    if (!slides.length) return;
    let index = 0, timer;
    const speed = Math.max(4000, Number(hero.dataset.speed || 6000));
    const autoplay = hero.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        const video = qs('video', slide);
        if (video) active ? video.play().catch(() => {}) : video.pause();
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };
    const stop = () => { if (timer) clearInterval(timer); timer = null; };
    const start = () => { stop(); if (autoplay && slides.length > 1) timer = setInterval(() => show(index + 1), speed); };
    qs('[data-o26-hero-prev]', hero)?.addEventListener('click', () => { show(index - 1); start(); });
    qs('[data-o26-hero-next]', hero)?.addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach(dot => dot.addEventListener('click', () => { show(Number(dot.dataset.o26HeroDot)); start(); }));
    let touchStartX = 0, touchStartY = 0;
    hero.addEventListener('touchstart', e => {
      const touch = e.changedTouches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      stop();
    }, { passive:true });
    hero.addEventListener('touchend', e => {
      const touch = e.changedTouches[0];
      const dx = touch.clientX - touchStartX;
      const dy = touch.clientY - touchStartY;
      if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.15) show(index + (dx < 0 ? 1 : -1));
      start();
    }, { passive:true });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    show(0);
    start();
  });

  // escape key
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrawer(); closeSearch(); closeMenu(); } });
  refreshCart(false);
})();
